import { Plugin } from '../models/Plugin'
import router from '../router'

export const install: Plugin['fn'] = (app) => {
  app.use(router)
}
